import type { Session } from '@supabase/supabase-js';

export function buildLocalChatsUrl(session: Session | null, orgId?: string | null) {
  const url = new URL('http://127.0.0.1:8090/chat');

  if (orgId) url.searchParams.set('orgId', orgId);

  return url.toString();
}
